import { css } from "@emotion/react";

import theme from "../../styles/theme";
import { black, white } from "../../styles/variables";

const { spacing } = theme;

// eslint-disable-next-line import/prefer-default-export
export const blank = css`
  width: 560px;
  height: 325px;
  margin-bottom: ${spacing(2.5)}px;
  background-color: ${black};
  color: ${white};
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
`;

export const info = css`
  color: #bababa;
`;
